// extracted by mini-css-extract-plugin
export default {"wrapper":"landscapeOverlay__wrapper__YgWpn","phoneIcon":"landscapeOverlay__phoneIcon__d4FBE","phoneRotate":"landscapeOverlay__phoneRotate__qjNqT"};